<template>
  <div class="customer pb-4">
      <sectionHeader :text="customers.header"/>
      <b-row>
        <b-col v-for="(customer, i) in customers.list" :key="i" sm="12" md="4">
          <img v-if="customer.imgSrc === 'combitech'" src="./assets/combitech.jpg" />
          <img v-else-if="customer.imgSrc === 'msb'" src="./assets/msb.jpg" />
          <img v-else-if="customer.imgSrc === 'swedavia'" src="./assets/swedavia.jpg" />
          <img v-else-if="customer.imgSrc === 'vattenfall'" src="./assets/vattenfall.jpg" />
          <img v-else-if="customer.imgSrc === 'sl'" src="./assets/sl.jpg" />
          <img v-else-if="customer.imgSrc === 'forsvarsmakten'" src="./assets/forsvarsmakten.jpg" />
          <sectionText :text="customer.text"/>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import sectionHeader from '../text/SectionHeader'
import sectionSummary from '../text/SectionSummary'
import sectionText from '../text/SectionText'
import ulList from '../list/ULList'

const SECTIONID = 8

export default {
  name: 'customers',
  props: ['language'],
  components: {
    sectionHeader,
    sectionSummary,
    sectionText,
    ulList
  },
  data () {
    return {
      customers: {
        header: '',
        list: []
      },
      partners: {
        header: '',
        summary: '',
        text: ''
      },
      ibm: {
        header: '',
        list: []
      },
      arcgis: {
        header: '',
        list: []
      }
    }
  },
  watch: {
    language: function () {
      this.handleLanguage()
    }
  },
  created: function () {
    this.handleLanguage()
  },
  methods: {
    handleLanguage: function () {
      this.customers = {
        header: this.$root.getCategoryHeader(SECTIONID, 0),
        list: this.$root.getCategoryList(SECTIONID, 0)
      }
    }
  }
}
</script>

<style scoped>

.md-header > * {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/about/Customers.vue